/**
 * Created by smizrahi on 7/27/16.
 */

export const STEP_MSCORE_TYPE = 'mscore';

export const STEP_DIRECTION_DL = 'download';
export const STEP_DIRECTION_UP = 'upload';

export default class ConfigStepMscore {
    constructor(servers, params, module, portalUrl) {
        this.type = STEP_MSCORE_TYPE;
        this.params = params;
        /**
         * @type {string}
         */
        this.portalUrl = portalUrl;
        /**
         * @type {array}
         */
        this.servers = servers;
        if (module) {
            this.module = parseInt(module);
        } else {
            this.module = null;
        }

        Object.freeze(params);
        Object.freeze(this);
    }

    /**
     * @return {string} the direction
     */
    getDirection() {
        if (parseInt(this.params.da_direction) === 1) {
            return STEP_DIRECTION_UP;
        }
        return STEP_DIRECTION_DL;
    }

    /**
     * @return {Number} the service id
     */
    getService() {
        return parseInt(this.params.da_service);
    }

    /**
     * @return {number} the socket count
     */
    getSocketCount() {
        if (this.params.nbsocket) {
            let nbSocket = parseInt(this.params.nbsocket);
            if (nbSocket > 5) nbSocket = 5; // Fix max socket to 5
            return nbSocket;
        }
        return 1;
    }

    /**
     *
     * @return {number} the volume in bytes
     */
    getVolume() {
        return parseInt(this.params.volume);
    }

    /**
     * @return {number} the timeout in ms
     */
    getTimeout() {

        if (this.params.da_service == 4) {
            // Scoring
            return (parseInt(this.params.emodel_duration) + (this.params.logsextratime ? parseInt(this.params.logsextratime) : 0));
        } else {
            // Other
            return (parseInt(this.params.timeout) + (this.params.logsextratime ? parseInt(this.params.logsextratime) : 0));
        }
    }

    /**
     * @return {int} the port
     */
    getPort() {
        return parseInt(this.params.port);
    }

    /**
     * @return {Boolean} true if logs are enabled
     */
    isLogEnabled() {
        return this.params.logs === 'yes';
    }

    /**
     * @return {int} the module
     */
    getModule() {
        return parseInt(this.module);
    }

    /**
     * @return {string} the portal URL
     */
    getPortalUrl() {
        return this.portalUrl;
    }

    /**
     * @return {array} the params
     */
    getParams() {
        return this.params;
    }

    static restore(obj) {

        return new ConfigStepMscore(
            obj.servers,
            obj.params,
            obj.module,
            obj.portalUrl
        );
    }
}


// WEBPACK FOOTER //
// ./js/core/configuration/config/ConfigStepMscore.js